import React, { useState } from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  Stack
} from '@mui/material';
import {
  ExpandMore,
  HelpOutline,
  QuestionAnswer
} from '@mui/icons-material';

const FAQ = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqData = [
    {
      id: 1,
      question: 'Comment puis-je créer un compte sur Tchamba Marketplace ?',
      answer: 'Pour créer un compte, cliquez sur "Connexion" dans le menu, puis sur "Inscription". Remplissez le formulaire avec vos informations personnelles et validez votre email pour activer votre compte.'
    },
    {
      id: 2,
      question: 'Comment fonctionnent les formules d\'abonnement ?',
      answer: 'Nos formules d\'abonnement permettent aux vendeurs de créer et gérer leurs boutiques et produits. Chaque formule offre un nombre spécifique de produits. Consultez la section "Nos Formules d\'Abonnement" pour voir les détails de chaque formule.'
    },
    {
      id: 3,
      question: 'Comment puis-je contacter un vendeur ?',
      answer: 'Sur chaque fiche produit, vous trouverez les boutons WhatsApp et Appeler pour contacter directement le vendeur. Vous pouvez également consulter les informations de contact dans la page de détails de la boutique.'
    },
    {
      id: 4,
      question: 'Qu\'es ce que je peux vendre sur Tchamba Marketplace ?',
      answer: 'Vous pouvez vendre tous les produits que vous souhaitez. Tout ce que vous vendez doit être conforme à la loi et aux conditions d\'utilisation de Tchamba Marketplace.'
    },
    {
      id: 5,
      question: 'Je n\'ai pas de boutique mais je peux rendre des services contre paiement.Que faire ?',
      answer: ' Tu peux créer un compte utilisateur et contacter l\'administrateur pour ajouter tes services pour toi sur la plateforme.'
    },
    {
      id: 6,
      question: 'Comment devenir vendeur sur Tchamba Marketplace ?',
      answer: 'Pour devenir vendeur, vous devez d\'abord créer un compte utilisateur, puis vous abonner à une de nos formules d\'abonnement. Une fois votre abonnement activé, vous pourrez créer votre boutique et commencer à ajouter vos produits.'
    }
  ];

  return (
    <Box
      sx={{
        py: 8,
        background: 'linear-gradient(180deg, rgba(249, 250, 251, 0) 0%, rgba(249, 250, 251, 1) 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Background decorative elements */}
      <Box
        sx={{
          position: 'absolute',
          top: -100,
          right: -100,
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(249, 115, 22, 0.05) 0%, rgba(236, 72, 153, 0.05) 100%)',
          filter: 'blur(80px)',
          zIndex: 0
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -100,
          left: -100,
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.05) 0%, rgba(249, 115, 22, 0.05) 100%)',
          filter: 'blur(80px)',
          zIndex: 0
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Stack spacing={4} alignItems="center">
          {/* Header */}
          <Box sx={{ textAlign: 'center', maxWidth: 700 }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #f97316 0%, #ef4444 50%, #ec4899 100%)',
                mb: 3,
                animation: 'pulse 2s ease-in-out infinite',
                '@keyframes pulse': {
                  '0%, 100%': {
                    transform: 'scale(1)',
                    boxShadow: '0 0 0 0 rgba(249, 115, 22, 0.7)'
                  },
                  '50%': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 0 0 20px rgba(249, 115, 22, 0)'
                  }
                }
              }}
            >
              <QuestionAnswer sx={{ fontSize: 40, color: 'white' }} />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                mb: 2,
                background: 'linear-gradient(90deg, #f97316 0%, #ef4444 50%, #ec4899 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Questions fréquentes
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Trouvez rapidement les réponses à vos questions les plus courantes
            </Typography>
          </Box>

          {/* FAQ Accordion */}
          <Box sx={{ width: '100%', maxWidth: 900 }}>
            <Stack spacing={2}>
              {faqData.map((faq, index) => (
                <Accordion
                  key={faq.id}
                  expanded={expanded === `panel${faq.id}`}
                  onChange={handleChange(`panel${faq.id}`)}
                  sx={{
                    borderRadius: 3,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    '&:before': {
                      display: 'none'
                    },
                    '&:hover': {
                      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                      transform: 'translateY(-2px)'
                    },
                    '&.Mui-expanded': {
                      margin: '16px 0',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                    },
                    animation: `fadeInUp 0.5s ease ${index * 0.1}s both`,
                    '@keyframes fadeInUp': {
                      from: {
                        opacity: 0,
                        transform: 'translateY(20px)'
                      },
                      to: {
                        opacity: 1,
                        transform: 'translateY(0)'
                      }
                    }
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMore
                        sx={{
                          color: 'primary.main',
                          transition: 'transform 0.3s ease',
                          transform: expanded === `panel${faq.id}` ? 'rotate(180deg)' : 'rotate(0deg)'
                        }}
                      />
                    }
                    sx={{
                      px: 3,
                      py: 2,
                      minHeight: 72,
                      '&.Mui-expanded': {
                        minHeight: 72,
                        backgroundColor: 'rgba(249, 115, 22, 0.05)'
                      },
                      '&:hover': {
                        backgroundColor: 'rgba(249, 115, 22, 0.03)'
                      }
                    }}
                  >
                    <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          background: 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)',
                          flexShrink: 0
                        }}
                      >
                        <HelpOutline sx={{ fontSize: 20, color: 'white' }} />
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: 'text.primary',
                          flex: 1
                        }}
                      >
                        {faq.question}
                      </Typography>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      px: 3,
                      pb: 3,
                      pt: 0,
                      backgroundColor: expanded === `panel${faq.id}` ? 'rgba(249, 115, 22, 0.02)' : 'transparent',
                      transition: 'background-color 0.3s ease'
                    }}
                  >
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{
                        lineHeight: 1.8,
                        pl: 7,
                        animation: expanded === `panel${faq.id}` ? 'fadeIn 0.4s ease' : 'none',
                        '@keyframes fadeIn': {
                          from: {
                            opacity: 0,
                            transform: 'translateY(-10px)'
                          },
                          to: {
                            opacity: 1,
                            transform: 'translateY(0)'
                          }
                        }
                      }}
                    >
                      {faq.answer}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default FAQ;

